<script setup>
import {ref, reactive, onMounted, nextTick} from "vue"
import YTCard from "@/components/YTCard/YTCard.vue";
import YTFormDialog from "@/components/YTFormDialog/index.vue"
import router from "@/router/index.js";
import {getRoute} from "@/hooks/getRoute.js";
import {addPropertyGroup, editPropertyGroup, propertyGroupItem} from "@/api/propertyGroup/propertyGroup.js";
import BoxUpload from "@/components/YTBoxUpload/index.vue";

/*获取路由信息，带参则为修改*/
const {route} = getRoute()
// 带参则为修改
const isEdit = ref(false)
onMounted(() => {
  isEdit.value = Boolean(route.query.itemPropId)
  if (isEdit.value) getDetail(route.query.itemPropId)
})
/*获取商品信息*/
const getDetail = async (itemId) => {
  loading.value = true
  try {
    const res = await propertyGroupItem(itemId)
    if (!res) throw new Error("null")
    ruleForm.groupName = res.groupName
    ruleForm.groupNameEn = res.groupNameEn
    ruleForm.propertyGroupId = res.propertyGroupId
    ruleForm.propertyGroupItemList = res.propertyGroupItemList
    ruleForm.goodsCount = parseInt(res.goodsCount)
    tableData.value = res.propertyGroupItemList
    loading.value = false
  } catch (e) {
    console.log(e)
    if (e.message === "null") {
      ElMessage({
        type: "warning",
        message: "暂无此商品属性数据",
        duration: 3000,
        onClose: () => {
          router.push("/listItemProp")
        }
      })
    }
  }
}

/*表格数据展示*/
const loading = ref(false);
const headers = ref([
  { title: '序号', key: 'sort', width: '100px', sortable: false },
  { title: '属性值', key: 'propertyName', sortable: false },
  { title: 'English', key: 'propertyNameEn', sortable: false },
  { title: '加价（元）', key: 'addPrice', width: '200px', sortable: false },
  { title: '商品属性图片', key: 'image', width: '200px', sortable: false },
  { title: '排序', key: 'orderBy', width: '100px', sortable: false },
  { title: '操作', key: 'controls', width: '100px', sortable: false },
])
// 表单组件锚点
const ruleFormRef = ref()
// 表格数据
const tableData = ref([])
// 表单信息
const ruleForm = reactive({
  propertyGroupId: null,
  groupName: null,
  groupNameEn: "Coming Soon ...",
  propertyGroupItemList: [],
  goodsCount: 0
})
// 校验商品属性项名称
const checkGroupName = (rule, value, callback) => {
  if (!ruleForm.groupName) {
    return callback(new Error("属性项名称（中文）不能为空！"))
  }
  if (!ruleForm.groupNameEn) {
    return callback(new Error("属性项名称（English）不能为空！"))
  }
  return callback()
}
// 表单校验规则
const rules = reactive({
  groupName: [
    {required: true, validator: checkGroupName, trigger: 'blur'},
  ]
})

// 处理新增属性值
const handleAddProp = () => {
  open.value = true
  isShowUpload.value = true
}
// 取消新增
const cancelAdd = () => {
  router.back()
}
// 保存校验表单
const submit = async () => {
  loading.value = true
  await ruleFormRef.value.validate(async (valid, fields) => {
    if (valid) {
      await createPropGroup()
    } else {
      ElMessage.error("请根据提示修改表单信息")
      loading.value = false
    }
  })
}
// 创建属性项
const createPropGroup = async () => {
  ruleForm.propertyGroupItemList = tableData.value
  console.log("isEdit.value", isEdit.value)
  console.log("ruleForm", ruleForm)
  if (isEdit.value) {
    await editPropertyGroup(ruleForm)
  } else {
    await addPropertyGroup(ruleForm)
  }
  ElMessage({
    type: "success",
    message: isEdit.value ? "修改成功" : "创建成功",
    duration: 3000
  })
  loading.value = false
  router.push("/listItemProp")
}
// 属性值上移
const handlePropUp = (index) => {
  // 判断传入的index是否在有效范围内
  if (index === 0) {
    ElMessage.warning("已经是第一啦~")
    return;
  }
  [tableData.value[index].sort, tableData.value[index - 1].sort] = [tableData.value[index - 1].sort, tableData.value[index].sort];
  [tableData.value[index], tableData.value[index - 1]] = [tableData.value[index - 1], tableData.value[index]];
}
// 属性值下移
const handlePropDown = (index) => {
  // 判断传入的index是否在有效范围内
  if (index === tableData.value.length - 1) {
    ElMessage.warning("已经是最后啦~")
    return;
  }
  [tableData.value[index].sort, tableData.value[index + 1].sort] = [tableData.value[index + 1].sort, tableData.value[index].sort];
  [tableData.value[index], tableData.value[index + 1]] = [tableData.value[index + 1], tableData.value[index]];
}
// 移除属性值
const handleRemove = (index) => {
  tableData.value.splice(index, 1)
}

/*新增属性对话框*/
// 对话框加载状态
const dialogLoading = ref(false)
// 对话框打开状态
const open = ref(false)
// 对话框表单锚点
const dialogRuleFormRef = ref()
// 对话框表单
const dialogRuleForm = reactive({
  propertyName: null,
  propertyNameEn: "Coming Soon ...",
  addPrice: 0,
  image: null
})
// 商品属值名称校验规则
const checkPropertyName = (rule, value, callback) => {
  if (!dialogRuleForm.propertyName) {
    return callback(new Error("属性值名称（中文）不能为空！"))
  }
  if (!dialogRuleForm.propertyNameEn) {
    return callback(new Error("属性值名称（English）不能为空！"))
  }
  return callback()
}
// 对话框表单校验规则
const dialogRules = reactive({
  propertyName: [
    {required: true, validator: checkPropertyName, trigger: 'blur'},
  ],
})
// 关闭对话框
const closeDialog = () => {
  // 关闭对话框
  open.value = false
  clearDialog()
  // 清空表单校验
  dialogRuleFormRef.value.clearValidate()
}
// 清空表单信息
const clearDialog = async () => {
  dialogRuleForm.propertyName = null
  dialogRuleForm.propertyNameEn = "Coming Soon ..."
  dialogRuleForm.addPrice = 0
  dialogRuleForm.propertyGroupId = null
  dialogRuleForm.propertyGroupItemId = null
  dialogRuleForm.sort = null
  dialogRuleForm.image = null
  // 清空上传列表展示的文件
  isShowUpload.value = false
  isEditProp.value = false
}
// 处理新增属性值列表
const handleAddPropList = (item) => {
  tableData.value.push(item)
}
// 处理编辑属性值列表
const handleEditPropList = async () => {
  // TODO 逻辑有误，新建时修改属性值，会导致搜索到的propertyGroupItemId都相同，导致修改失败
  const findItemIndex = tableData.value.findIndex(i => i.propertyGroupItemId === dialogRuleForm.propertyGroupItemId)
  tableData.value[findItemIndex].propertyName = dialogRuleForm.propertyName
  tableData.value[findItemIndex].propertyNameEn = dialogRuleForm.propertyNameEn
  tableData.value[findItemIndex].addPrice = dialogRuleForm.addPrice
  tableData.value[findItemIndex].sort = dialogRuleForm.sort
  tableData.value[findItemIndex].image = dialogRuleForm.image
}
// 提交新增属性值 1：确定 2：确定并继续新增
const submitDialog = (index) => {
  dialogRuleFormRef.value.validate(async value => {
    if (value) {
      try {
        if (isEditProp.value) {
          await handleEditPropList()
        } else {
          console.log("dialogRuleForm", dialogRuleForm)
          const pushParam = {
            propertyGroupItemId: null,
            ...dialogRuleForm,
            sort: tableData.value.length + 1
          }
          handleAddPropList(pushParam)
        }
        if (index === 2) {
          console.log("dialogRuleForm.image", dialogRuleForm.image)
          await clearDialog()
          isShowUpload.value = true
          ElMessage({
            type: "success",
            message: "新增成功",
            appendTo: document.getElementsByClassName("v-overlay")[0],
          })
        } else {
          closeDialog()
        }
      } catch (e) {
        console.log(e)
      }
    } else {
      ElMessage({
        type: "error",
        message: "请根据提示修改表单信息",
        appendTo: document.getElementsByClassName("v-overlay")[0],
      })
    }
  })
}
// 是否编辑属性值
const isEditProp = ref(false)
// 编辑属性值
const editPropValue = (item) => {
  open.value = true
  isShowUpload.value = true
  dialogRuleForm.addPrice = item.addPrice
  dialogRuleForm.propertyGroupId = item.propertyGroupId
  dialogRuleForm.propertyGroupItemId = item.propertyGroupItemId
  dialogRuleForm.propertyName = item.propertyName
  dialogRuleForm.propertyNameEn = item.propertyNameEn
  dialogRuleForm.sort = item.sort
  dialogRuleForm.image = item.image
  if (dialogRuleForm.image) {
    // 反显商品属性图片
    nextTick(() => {
      handleReviewPic([dialogRuleForm.image])
    })
  }
  isEditProp.value = true
  console.log("item", item)
}

/*图片上传组件*/
// 是否展示上传组件，用于清空上传完成的缓存
const isShowUpload = ref(true)
// 商品图片上传组件锚点
const boxUploadRef = ref()
// 处理图片反显
const handleReviewPic = (reviewList) => {
  boxUploadRef.value.handleReview(reviewList)
}
// 处理图片上传成功
const handlePicSuccess = (url) => {
  dialogRuleForm.image = null
  dialogRuleForm.image = url[0]
  dialogLoading.value = false
}
// 处理图片列表改变
const handleImageRemove = (url) => {
  dialogRuleForm.image = url[0]
}

/*中英文切换输入框相关Tab*/
// 属性项名称tab
const groupNameTab = ref("zh")
// 属性值tab
const propertyNameTab = ref("zh")
</script>

<template>
  <el-form
      ref="ruleFormRef"
      :model="ruleForm"
      :rules="rules"
      label-width="auto"
      class="demo-ruleForm container_form mg_b_3"
      size="large"
      v-loading="loading">
    <YTCard :title="'属性项信息'" :isRetract="false" :isShowDivider="false" :is-show-title-line="true">
      <template #container>
        <el-form-item label="属性项名称：" prop="groupName">
          <el-tabs
              v-model="groupNameTab"
              type="card"
              class="demo-tabs"
          >
            <el-tab-pane label="中文" name="zh">
              <el-input style="width: 350px" v-model="ruleForm.groupName" placeholder="请输入商品属性项名称" />
            </el-tab-pane>
            <el-tab-pane label="English" name="en">
              <el-input style="width: 350px" v-model="ruleForm.groupNameEn" placeholder="Please enter the name of the commodity attribute item" />
            </el-tab-pane>
          </el-tabs>
        </el-form-item>
      </template>
    </YTCard>
    <YTCard :title="'属性值列表'" :isRetract="false" :isShowDivider="false" :is-show-title-line="true">
      <template #container>
        <v-btn class="mg_b_2" color="success" @click="handleAddProp">新增属性值</v-btn>
        <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loading"
            :no-data-text="'没有更多数据了~'"
            no-filter
            hover
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
          </template>

          <template v-slot:item.number="{ index }">
            {{index + 1}}
          </template>

          <template v-slot:item.image="{ item }">
            <div v-if="item.image" class="flex_left">
              <el-avatar shape="square" :size="80" fit="contain" :src="item.image" />
            </div>
            <div v-else>
              -
            </div>
          </template>

          <template v-slot:item.orderBy="{ index }">
            <div class="flex_left">
              <v-row>
                <v-col cols="6">
                  <el-tooltip
                      class="box-item"
                      effect="dark"
                      content="上移"
                      placement="left">
                    <v-icon class="cursor-pointer" @click="handlePropUp(index)" icon="mdi-arrow-up-bold"></v-icon>
                  </el-tooltip>
                </v-col>
                <v-col cols="6">
                  <el-tooltip
                      class="box-item"
                      effect="dark"
                      content="下移"
                      placement="right">
                    <v-icon class="cursor-pointer" @click="handlePropDown(index)" icon="mdi-arrow-down-bold"></v-icon>
                  </el-tooltip>
                </v-col>
              </v-row>
            </div>
          </template>

          <template v-slot:item.controls="{ item, index }">
            <div class="flex_center">
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="编辑"
                  placement="left">
                <v-icon icon="mdi-file-edit-outline" color="primary" size="small" @click="editPropValue(item)"></v-icon>
              </el-tooltip>
              <el-popconfirm @confirm="handleRemove(index)" :title="`删除后，收银开单商品将无法选择该属性值`">
                <template #reference>
                  <div>
                    <el-tooltip
                        class="box-item"
                        effect="dark"
                        content="删除"
                        placement="right">
                      <v-icon color="error" class="cursor-pointer" icon="mdi-close" v-if="ruleForm.goodsCount === 0"></v-icon>
                    </el-tooltip>
                  </div>
                </template>
                <template #actions="{ confirm, cancel }">
                  <div class="flex_bt">
                    <v-btn size="small" @click="cancel">取消</v-btn>
                    <v-btn size="small" color="primary" @click="confirm">确定</v-btn>
                  </div>
                </template>
              </el-popconfirm>
            </div>
          </template>
          <template v-slot:bottom>

          </template>
        </v-data-table>
      </template>
    </YTCard>
    <v-row>
      <v-col cols="12">
        <v-row>
          <v-col cols="4" offset="2">
            <v-btn @click="cancelAdd">取消</v-btn>
          </v-col>
          <v-col cols="4">
            <v-btn color="primary" @click="submit">保存</v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </el-form>
  <YTFormDialog :open="open" :title="isEditProp ? '编辑属性值' : '新增属性值'" :max-width="800">
    <template v-slot:content="{form}">
      <el-form
          ref="dialogRuleFormRef"
          :model="dialogRuleForm"
          :rules="dialogRules"
          label-width="auto"
          class="demo-ruleForm"
          size="large"
          v-loading="loading">
        <el-form-item label="属性值名称：" prop="propertyName">
          <el-tabs
              v-model="propertyNameTab"
              type="card"
              class="demo-tabs"
          >
            <el-tab-pane label="中文" name="zh">
              <el-input style="width: 250px" v-model="dialogRuleForm.propertyName" placeholder="请输入商品属性值名称" />
            </el-tab-pane>
            <el-tab-pane label="English" name="en">
              <el-input style="width: 250px" v-model="dialogRuleForm.propertyNameEn" placeholder="Please enter the name of the commodity attribute value" />
            </el-tab-pane>
          </el-tabs>
        </el-form-item>
        <el-form-item label="加价：" prop="addPrice">
          <el-input-number :precision="2" :min="0" style="width: 250px" v-model="dialogRuleForm.addPrice" placeholder="请输入加价金额" />
        </el-form-item>
        <el-form-item label="商品属性图片：" prop="image">
          <BoxUpload v-if="isShowUpload" ref="boxUploadRef" :ali-oss-path="'PROPERTY_ITEM'" :width="800" :height="800" :limit="1" :file-size="1" @progress="loading = true" @remove="handleImageRemove" @success="handlePicSuccess"></BoxUpload>
        </el-form-item>
      </el-form>
    </template>
    <template v-slot:actions="{form}">
      <v-row>
        <v-col cols="5" offset="7">
          <v-btn class="mg_r_2" color="primary" variant="elevated" @click="submitDialog(1)">确定</v-btn>
          <v-btn class="mg_r_2" v-if="!isEditProp" color="success" variant="elevated" @click="submitDialog(2)">确定并继续新增</v-btn>
          <v-btn variant="elevated" @click="closeDialog">取消</v-btn>
        </v-col>
      </v-row>
    </template>
  </YTFormDialog>
</template>

<style scoped>

</style>
